function TeamService($http, $httpParamSerializer, $rootScope, $q, AppSettings, AuthService, CommonService) {
    'ngInject';

    const service = {};

    service.adminManageTeam = function(params) {
        const url = AppSettings.apiUrl.restRoot + 'admin/manage_team';

        return CommonService.post(url, params);
    }

    return service;
}

export default {
    name: 'TeamService',
    fn: TeamService
}